import { useQuery } from 'react-query';
import { InsurancePolicyPackage } from '../../../../../../advisory-report/src/types/AdvisoryReport';
import { wgApi } from '../../../../../../app/src/features/api/wgApi';

export interface InsurencePoliciesResponse {
  items: InsurancePolicyPackage[];
}

export interface InsurencePolicyPackagesPartialResponse {
  items: Partial<InsurancePolicyPackage>[];
}

interface Params {
  partyId: string;
}

const getInsurancePolicyPackages = async ({ partyId }: Params) => {
  const { data, isError } = await wgApi.get<InsurencePoliciesResponse>(
    `/v1/api/parties/${partyId}/policy-packages`,
  );
  if (isError) throw new Error();
  return data;
};

export const getUseInsurancePolicyPackagesQKey = ({ partyId }: Params) => [
  'parties',
  'insurance-policy-packages',
  partyId,
];

export const useInsurancePolicyPackages = (params: Params) => {
  return useQuery(
    getUseInsurancePolicyPackagesQKey(params),
    () => getInsurancePolicyPackages(params),
    {
      enabled: !!params.partyId,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  );
};
